<!-- eslint-disable vue/no-use-v-if-with-v-for -->
<!-- eslint-disable vue/valid-v-for -->
<!-- eslint-disable vue/no-template-key -->
<template>
  <v-navigation-drawer
    v-if="user"
    id="main-sidebar"
    v-model="sidebarDrawer"
    light
    color="primary"
    width="244"
    mobile-breakpoint="960"
    :right="$vuetify.rtl"
    :mini-variant="miniVariant"
    mini-variant-width="70"
    app
  >
    <div class="sidebar-brand" @click="() => $router.push('/', () => {})">
      <template v-if="!miniVariant">
        <img src="@/assets/logo-black.svg" height="60" alt="Snabb" />
        <v-spacer />
      </template>
      <v-btn icon small @click.stop="miniVariant = !miniVariant">
        <v-icon>mdi-page-layout-sidebar-left</v-icon>
      </v-btn>
    </div>

    <v-list expand nav rounded class="sidebar-nav">
      <v-list-item-group color="secondary">
        <template v-for="(item, i) in items">
          <!-- Render a group only if it has visible subMenuItems -->
          <v-list-group
            v-if="item.subMenuItems && hasVisibleSubItems(item.subMenuItems)"
            :key="`item-${i}`"
            v-model="item.expanded"
            no-action
            color="secondary"
          >
            <template #activator>
              <v-list-item-icon v-if="item.icon">
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item-content>
            </template>

            <v-list-item
              v-for="(subItem, index) in item.subMenuItems"
              v-if="subItem.isVisible(user)"
              :key="`subitem-${index}`"
              :to="subItem.to"
              exact
              class="sidebar-subitem"
              link
            >
              <v-list-item-icon v-if="subItem.icon">
                <v-icon small>{{ subItem.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ subItem.title }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>

          <!-- Render standalone items only if they don't have subMenuItems -->
          <v-list-item
            v-if="!item.subMenuItems && showItem(item)"
            :key="`std-${i}`"
            :to="item.href ? undefined : item.to"
            :href="item.href"
            link
          >
            <v-list-item-icon>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list-item-group>
    </v-list>

    <!-- User, pinned to the bottom -->
    <template v-slot:append>
      <div class="sidebar-footer">
        <v-list-item
          class="user-box"
          @click.stop="() => $router.push('/profile', () => {})"
        >
          <v-list-item-avatar size="32">
            <avatar
              v-if="isAuthenticated"
              :badge="false"
              :text="user ? user.name : ''"
              size="32"
              class="primary"
            />
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title class="text-truncate">{{
              user ? user.name : ''
            }}</v-list-item-title>
            <v-list-item-subtitle class="text-truncate">{{
              user ? user.email : ''
            }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </div>
    </template>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters } from 'vuex'
import Avatar from '@/components/commonComponents/Avatar'

export default {
  name: 'Sidebar',
  components: {
    Avatar
  },
  data() {
    return {
      miniVariant: false,
      items: [
        {
          icon: 'mdi-format-list-checks',
          title: this.$vuetify.lang.t('$vuetify.DASHBOARD.WHITELISTS'),
          i18n: 'DASHBOARD.WHITELISTS',
          href: '/v3/whitelists',
          isVisible: user => {
            return user.isAdmin || user.isPlaceAdmin || user.isWhitelistManager
          }
        },
        {
          icon: 'mdi-car',
          title: this.$vuetify.lang.t('$vuetify.DASHBOARD.FLEETS'),
          i18n: 'DASHBOARD.FLEETS',
          to: '/fleets',
          isVisible: user => {
            return user.isAdmin || user.isPlaceAdmin || user.isFleetManager
          }
        },
        {
          icon: 'mdi-chart-box',
          title: this.$vuetify.lang.t('$vuetify.DASHBOARD.SESSIONS_TITLE'),
          i18n: 'DASHBOARD.SESSIONS_TITLE',
          to: '/sessions',
          placeAdminCanSee: true,
          isVisible: user => {
            return user.canViewParkings
          }
        },
        {
          icon: 'mdi-calendar',
          title: this.$vuetify.lang.t('$vuetify.DASHBOARD.BOOKING'),
          i18n: 'DASHBOARD.BOOKING',
          to: '/booking',
          isVisible: user => {
            return user.canViewBookings
          }
        },
        {
          icon: 'mdi-ticket-confirmation',
          title: this.$vuetify.lang.t('$vuetify.DASHBOARD.DAY_PASSES'),
          i18n: 'DASHBOARD.DAY_PASSES',
          // Entry passes live in the v3 app. Full-page nav there — same origin in prod (Firebase
          // rewrites /v3/**) and dev (the v2 dev server proxies /v3), so a relative path keeps the
          // shared session intact.
          href: '/v3/jurmala',
          target: '_self',
          isVisible: user => {
            return user.canSeeJurmalaDayPasses
          }
        },
        {
          icon: 'mdi-monitor',
          title: this.$vuetify.lang.t('$vuetify.DASHBOARD.KIOSKS'),
          i18n: 'DASHBOARD.KIOSKS',
          // Kiosks live in the v3 app only (no native v2 view).
          href: '/v3/kiosks',
          target: '_self',
          isVisible: user => {
            return user.canViewKiosks
          }
        },
        {
          icon: 'mdi-file-chart',
          title: this.$vuetify.lang.t('$vuetify.REPORTS.TITLE'),
          i18n: 'REPORTS.TITLE',
          to: '/report',
          isVisible: user => {
            return user.canViewReports
          }
        },
        {
          icon: 'mdi-map',
          title: this.$vuetify.lang.t('$vuetify.DASHBOARD.PLACES_TITLE'),
          i18n: 'DASHBOARD.PLACES_TITLE',
          to: '/places',
          placeAdminOnly: true,
          operatorCanSee: true
        },
        {
          icon: 'mdi-bullhorn',
          title: this.$vuetify.lang.t('$vuetify.DASHBOARD.CAMPAIGNS'),
          i18n: 'DASHBOARD.CAMPAIGNS',
          to: '/campaigns',
          isVisible: user => {
            return user.canViewCampaigns
          }
        },
        {
          icon: 'mdi-account',
          title: this.$vuetify.lang.t('$vuetify.DASHBOARD.USERS'),
          i18n: 'DASHBOARD.USERS',
          to: '/users',
          placeAdminCanSee: true
        },
        {
          icon: 'mdi-eye',
          title: this.$vuetify.lang.t('$vuetify.ENFORCEMENT.ENFORCEMENT'),
          i18n: 'ENFORCEMENT.ENFORCEMENT',
          to: '/enforcement?tab=parkingFines',
          forEnforcer: true,
          expanded: false,
          subMenuItems: [
            {
              title: this.$vuetify.lang.t('$vuetify.ENFORCEMENT.PARKING_FINES'),
              to: '/enforcement?tab=parking-fines',
              isVisible: user => {
                return (
                  user.canViewParkingFines ||
                  user.canCancelParkingFines ||
                  this.isGlobalAdmin
                )
              }
            },
            {
              title: this.$vuetify.lang.t(
                '$vuetify.ENFORCEMENT.PARKING_STATUS_CHECK_LOGS'
              ),
              to: '/enforcement?tab=parking-status-check-logs',
              isVisible: () => {
                return this.isGlobalAdmin
              }
            },
            {
              title: this.$vuetify.lang.t(
                '$vuetify.ENFORCEMENT.PARKING_FINE_REPORTS.TITLE'
              ),
              to: '/enforcement?tab=parking-fine-reports',
              isVisible: () => {
                return this.isGlobalAdmin
              }
            }
          ]
        },
        {
          icon: 'mdi-alert',
          title: this.$vuetify.lang.t('$vuetify.CAR_WASH_DISPUTES.TITLE'),
          i18n: 'CAR_WASH_DISPUTES.TITLE',
          to: '/disputes',
          globalAdminOnly: true
        }
      ]
    }
  },
  computed: {
    ...mapGetters('authentication', [
      'user',
      'isAuthenticated',
      'isGlobalAdmin'
    ]),
    // A Jūrmala-only user (has CAN_SEE_JURMALA_DAY_PASSES but is not an admin) gets a locked-down
    // sidebar: nothing but the entry-passes item.
    isJurmalaOnly() {
      return (
        !!this.user && this.user.canSeeJurmalaDayPasses && !this.user.isAdmin
      )
    },
    sidebarDrawer: {
      get() {
        return this.$store.state.app.sidebarDrawer
      },
      set(val) {
        this.$store.commit('app/setSidebarDrawer', val)
      }
    }
  },
  methods: {
    hasVisibleSubItems(subMenuItems) {
      if (this.isJurmalaOnly) {
        return false
      }
      return subMenuItems.some(subItem => subItem.isVisible(this.user))
    },
    showItem(item) {
      if (this.isJurmalaOnly) {
        return item.i18n === 'DASHBOARD.DAY_PASSES'
      }
      if (item.isVisible) {
        return item.isVisible(this.user)
      }
      let show = true
      if (item.globalAdminOnly) {
        show = this.isGlobalAdmin
      }
      if (item.placeAdminOnly) {
        show = this.user.isPlaceAdmin
      }
      if (item.adminOnly) {
        show = this.user.isAdmin
      }
      if (item.placeAdminCanSee) {
        show = this.user.isAdmin || this.user.isPlaceAdmin
      }
      if (item.forEnforcer) {
        if (this.user.isAdmin) {
          show = true
        } else {
          show =
            this.user.canViewParkingFines || this.user.canCancelParkingFines
        }
      }
      if (item.to === '/places') {
        return this.showPlacesMenuItem()
      }
      return show
    },
    showPlacesMenuItem() {
      if (
        this.user.isPlaceAdmin ||
        this.user.isAdmin ||
        this.user.canEditAvailabilityTable ||
        this.user.hasOperatorRole
      ) {
        return true
      }
      return false
    }
  }
}
</script>

<style lang="scss" scoped>
#main-sidebar {
  ::v-deep .v-navigation-drawer__border {
    display: none;
  }
  .sidebar-brand {
    display: flex;
    align-items: center;
    padding: 22px 24px;
    cursor: pointer;
  }

  ::v-deep .sidebar-nav {
    padding: 0 16px;
  }

  ::v-deep .v-list-item {
    min-height: 0;
    line-height: 1;
    padding: 2px 12px;
    margin-bottom: 0;
    border-radius: 12px;
    color: rgba(20, 19, 18, 0.75);

    .v-list-item-icon {
      margin-right: 12px;
      margin-top: 0;
      margin-bottom: 0;
      align-self: center;
    }

    .v-icon {
      font-size: 20px;
      color: rgba(20, 19, 18, 0.75);
    }

    .v-list-item__title {
      font-size: 15px;
      font-weight: 400;
      line-height: 1.2;
      letter-spacing: normal;
      color: inherit;
    }

    &:hover {
      background: rgba(20, 19, 18, 0.08);
    }
  }

  ::v-deep .v-list-item--active,
  ::v-deep .v-list-item--active:hover {
    background: #141312;
    color: #fff;

    &::before {
      opacity: 0;
    }

    .v-icon {
      color: #fff;
    }

    .v-list-item__title {
      font-weight: 500;
    }
  }

  ::v-deep .sidebar-subitem {
    padding: 1px 12px;

    .v-icon {
      font-size: 18px;
    }

    .v-list-item__title {
      font-size: 14px;
    }
  }

  .sidebar-footer {
    padding: 0 16px 16px;
  }

  ::v-deep .user-box {
    min-height: 0;
    padding: 10px 12px;
    background: rgba(20, 19, 18, 0.1);
    border-radius: 12px;

    .v-list-item__title {
      font-size: 13px;
      font-weight: 500;
      line-height: 1.3;
    }

    .v-btn {
      color: #141312 !important;
    }
  }

  &.v-navigation-drawer--mini-variant {
    .sidebar-brand {
      justify-content: center;
      padding: 22px 0;
    }

    .sidebar-footer {
      padding: 0 8px 16px;
    }

    ::v-deep .v-list-item {
      justify-content: center;
      padding-left: 0;
      padding-right: 0;

      .v-list-item-icon,
      .v-list-item-avatar {
        margin-right: 0;
      }
    }
  }
}
</style>
